import useMoney from '../../../../../hooks/useMoney';
import { BusinessPolicyVoucherDTO } from '../../../../../services/modules/business-policies/businessPolicies.types';
import {
  VOUCHER_DISCOUNT_TYPE_RULES,
  getVoucherDetailLabel,
  getVoucherDiscountLabel,
} from '../../../../orders/conditions/orderConditionVoucher.utils';
import { useTranslation } from '../../../../translation/TranslationContext';

const useVoucherRow = (voucher: BusinessPolicyVoucherDTO) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  return {
    discountLabel: getVoucherDiscountLabel(voucher, formatMoney),
    detailLabel: getVoucherDetailLabel(voucher, translate),
    ruleLabels: VOUCHER_DISCOUNT_TYPE_RULES[voucher.discountType].map((rule) => translate(rule)),
  };
};

export default useVoucherRow;
